import { render, staticRenderFns } from "./HistoryShipping.vue?vue&type=template&id=5ea7d28b&"
import script from "./HistoryShipping.vue?vue&type=script&lang=js&"
export * from "./HistoryShipping.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTiket.scss?vue&type=style&index=0&lang=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports